<template>
    <div class="uditor-class"></div>
</template>

<script>
import '@/../static/ueditor/ueditor.config.js'
import '@/../static/ueditor/ueditor.all.min.js'
import '@/../static/ueditor/lang/zh-cn/zh-cn.js'
import '@/../static/ueditor/ueditor.parse.min.js'

const defaultUEConfig = {
    autoHeightEnabled: false,
    autoFloatEnabled: false,　　//是否工具栏可浮动
    initialContent:'请输入内容',   //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
    autoClearinitialContent: false, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
    initialFrameWidth: null,
    initialFrameHeight: null,
    enableAutoSave: false
}

export default {
    props: {
        config: {
            type: Object,
            default: function () {
                return defaultUEConfig;
            }
        },
        name: {
            type: String,
            default: 'editorValue'
        },
        serverUrl: {
            type: String,
            required: true
        },
        value: {
            type: String
        }
    },
    data () {
        return {
            ueObj: null
        }
    },
    computed: {
        getConfig () {
            let temp = {
                serverUrl: this.serverUrl || '',
                textarea: this.name || '',
                initialContent: this.value || ''
            }

            return {...this.config, ...temp};
        }
    },
    mounted () {
        this.ueObj = new UE.ui.Editor(this.getConfig);
        this.ueObj.addListener('blur', () => {
            let content = this.ueObj.getContent();
            this.$emit('input', content);
            this.$emit('change', content);
        });
        this.ueObj.render(this.$el);
        // this.ueObj = UE.getEditor('container', this.getConfig);
    },
    destroyed () {
        UE.delEditor(this.$el);
    },
    watch: {
        name (newVal) {
            if (this.ueObj) this.ueObj.setOpt('textarea', newVal || '');
        },
        serverUrl (newVal) {
            if (this.ueObj) this.ueObj.setOpt('serverUrl', newVal || '');
        },
        value (newVal) {
            if (this.ueObj) this.ueObj.setContent(newVal);
        }
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/UEditor/index.vue